import { useLoaderContext } from "./Loader";

/** Manipulates a page loader */
const useLoader = () => {
  const { start, stop, isLoading } = useLoaderContext();
  return [start, stop, isLoading];
};

export default useLoader;
